import * as z from 'zod';

export const PostalCodeSchema = z.object({
    id: z.number().int(),
    code: z.string(),
});

export type PostalCode = z.infer<typeof PostalCodeSchema>;
